import ErrorPageIcon from '@/assets/Icons/components/ErrorPageIcon';
import RefreshIcon from '@/assets/Icons/components/RefreshIcon';
import Button from '@/components/Button/Button';

const ErrorPage = () => {
  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className="flex flex-col items-center text-center gap-2">
        <div className="flex items-center gap-2">
          <ErrorPageIcon />{' '}
          <span className="text-ds-gray-700 font-medium text-lg">Something Went Wrong</span>
        </div>
        <p className="text-ds-gray-500 text-sm mb-4">
          Unable to load section. Refreshing may fix this issue.
        </p>
        <Button startIcon={<RefreshIcon />} onClick={handleRefresh} size="lg" color="outlined">
          Refresh Section
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
